import {ReactNode, useEffect, useState} from "react";
import {Transition, TransitionProps} from "@mantine/core";

type PropsBase = {
    /**
     * Required children or list of children.
     * @author Kacper Faber
     */
    children: ReactNode | ReactNode[];
}

type Props = PropsBase & Omit<TransitionProps, "mounted" | "children">;

/**
 * Animates your children appears when component is mounted.
 * @author Kacper Faber
 * @since 0.1.0
 */
function AnimateIn(props: Props) {
    const [isMounted, setMounted] = useState(false);

    /**
     * Component is mounted
     * @author Kacper Faber
     */
    const onComponentMounted = () => {
        setMounted(true);
    }

    useEffect(onComponentMounted, []);

    return (
        <Transition {...props} mounted={isMounted}>
            {
                style => (
                    <div style={style}>
                        {props.children}
                    </div>
                )
            }
        </Transition>
    );
}

export default AnimateIn;